import { render, staticRenderFns } from "./NavigationExtraBlock.vue?vue&type=template&id=ba1e51a6&scoped=true"
import script from "./NavigationExtraBlock.vue?vue&type=script&lang=js"
export * from "./NavigationExtraBlock.vue?vue&type=script&lang=js"
import style0 from "./NavigationExtraBlock.vue?vue&type=style&index=0&id=ba1e51a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1e51a6",
  null
  
)

export default component.exports